import { styled } from 'styled-components';
import { LoadingSpinner } from '@motili/ui';

interface RefreshOverlayProps {
    backgroundColor?: string;
    zIndex?: number;
}

const RefreshOverlayComponent = styled.div<RefreshOverlayProps>`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: ${props =>
        props.backgroundColor || 'rgba(255, 255, 255, 0.5)'};
    z-index: ${props => props.zIndex || 99};
`;
const RefreshSpinnerContainer = styled.div<RefreshOverlayProps>`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: ${props => props.zIndex || 99};
`;

const RefreshOverlay = ({ backgroundColor, zIndex }: RefreshOverlayProps) => {
    return (
        <>
            <RefreshOverlayComponent backgroundColor={backgroundColor} />
            <RefreshSpinnerContainer zIndex={zIndex}>
                <LoadingSpinner />
            </RefreshSpinnerContainer>
        </>
    );
};

export default RefreshOverlay;
